import { useMemo } from "react";
import { Paper, Title, Box, Text } from "@mantine/core";
import { BarChart } from "@mantine/charts";

/** Which events the beacon is actually sending, by name. */
export default function EventTypes({ byEventName, isLoading }) {
  const data = useMemo(
    () => (byEventName ?? []).slice(0, 10).map((e) => ({ name: e.name, count: e.count })),
    [byEventName]
  );

  if (isLoading) {
    return (
      <Paper p="md" withBorder>
        <Title order={4}>Event Types</Title>
        <Box h={250} style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Text c="dimmed">Loading...</Text>
        </Box>
      </Paper>
    );
  }

  return (
    <Paper p="md" withBorder>
      <Title order={4} mb="md">Event Types</Title>
      <Box h={250}>
        {data.length > 0 ? (
          <BarChart
            h={250}
            data={data}
            dataKey="name"
            orientation="vertical"
            series={[{ name: "count", label: "Events", color: "teal.6" }]}
            tickLine="y"
          />
        ) : (
          <Box h="100%" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Text c="dimmed">No data available</Text>
          </Box>
        )}
      </Box>
    </Paper>
  );
}
